export default {
  user: {
    __typename: 'LocalUser',
    isConnected: false,
    accessToken: '',
    refreshToken: ''
  },
  localBusiness: {
    __typename: 'LocalBusiness',
    id: ''
  },
  breadcrumbs: []
}
